import { useEffect, useState } from "react";

export const StrengthMeter = ({ value, isStrength }) => {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [progress, setProgress] = useState("");

  useEffect(() => {
    console.log(value)
    if (value !== undefined && value !== null && value.length > 0) {
      const strengthChecks = {
        length: 0,
        hasUpperCase: false,
        hasLowerCase: false,
        hasDigit: false,
        hasSpecialChar: false,
      };

      strengthChecks.length = value.length >= 10 ? true : false;
      strengthChecks.hasUpperCase = /[A-Z]+/.test(value);
      strengthChecks.hasLowerCase = /[a-z]+/.test(value);
      strengthChecks.hasDigit = /[0-9]+/.test(value);
      strengthChecks.hasSpecialChar = /[^A-Za-z0-9]+/.test(value);

      let verifiedList = Object.values(strengthChecks).filter((value) => value);

      let strength =
        verifiedList.length === 5
          ? "Strong"
          : verifiedList.length >= 2
            ? "Medium"
            : "Weak";

      setPassword(value);
      setProgress(`${(verifiedList.length / 5) * 100}%`);
      setMessage(strength);

      if (verifiedList.length === 5) { isStrength(true) } else { isStrength(false) }

      //console.log("verifiedList: ", `${(verifiedList.length / 5) * 100}%`);

    } else {
      isStrength(false)
    }
    //eslint-disable-next-line
  }, [value])

  const handleGetActiveColor = (type) => {
    if (type === "Strong") return "#8BC926";
    if (type === "Medium") return "#FEBD01";
    return "#FF0054";
  }

  return (<>
    {value.length > 0 && password.length !== 0 ? (<>
      <div>
        <div
          style={{
            width: progress,
            height: 3,
            backgroundColor: handleGetActiveColor(message),
          }}
        ></div>
      </div>
      <p style={{ color: handleGetActiveColor(message) }}>
        Your password is {message}
      </p>
    </>) : null
    }
  </>)
}